// extracted by mini-css-extract-plugin
module.exports = {"sortableTree":"manage_sortableTree__3qUgy","label":"manage_label__1hD6q","actions":"manage_actions__3qlcy"};